export default __webpack_public_path__ + "media/music/526dbe03de37556be0a5581794d0a6fe.mp3";